import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { CenterLecComment } from '../../../lib/types/models/center-lec-comment/center-lec-comment'
import { CenterLecCommentFilters } from '../../../lib/types/models/center-lec-comment/center-lec-input'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterLecComments(
  input: PaginationRequest<CenterLecCommentFilters> & { centerId: number }
) {
  const { centerId, ...rest } = input
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.centers.getCenterLecComments.url, { centerId }),
        rest
      )
    )
    .get<PaginationResponse<CenterLecComment>>()
}
